import React from 'react';
import { createPopup, closePopup } from '../../services/popupService';
import { PopupWrapper, NewPopupTitle, NewPopupSubtitle, Checkbox, CheckBoxWrapper } from './Popups.styles';
import { ButtonHolder, CommonBlueButton, ExpertToggleLockCancelButton } from '../common/buttonsComponents';
import { makeManualUnavailable, expertToggleLockConfirmation } from 'api/expert';
import { logout } from '../../api/user';
import { getGlobalParseConfigsList } from '../../api/platformConfig';

class ToggleLockPopup extends React.Component {
  state = {
    doNotShowThisMessageAgain: false,
    lockExpiresIn: '',
  };

  async UNSAFE_componentWillMount() {
    const { expertAvailabilitySwitchLockTime } = await getGlobalParseConfigsList(['expertAvailabilitySwitchLockTime']);
    this.setState({ lockExpiresIn: expertAvailabilitySwitchLockTime });
  }

  async handleAcknowledgeButtonClick(e) {
    const { doNotShowThisMessageAgain } = this.state;
    const { expertId, toggleButton, resolve } = this.props;
    if (doNotShowThisMessageAgain) {
      // update expert field expertReviewPopupAcknowledged
      expertToggleLockConfirmation(expertId);
    }
    closePopup();

    await makeManualUnavailable();

    if (!toggleButton) {
      await logout();
    }

    if (resolve) {
      this.props.resolve();
    }
  }

  handleClosePopup() {
    const { doNotShowThisMessageAgain } = this.state;
    const { expertId, resolve } = this.props;
    if (resolve) {
      this.props.resolve();
    }

    if (doNotShowThisMessageAgain) {
      expertToggleLockConfirmation(expertId);
    }

    closePopup();
  }

  handleCheckBoxClick() {
    this.setState({ doNotShowThisMessageAgain: !this.state.doNotShowThisMessageAgain });
  }

  render() {
    const { doNotShowThisMessageAgain, lockExpiresIn } = this.state;

    const timeAmount = lockExpiresIn.split(' ')[0];
    const timeUnit = lockExpiresIn.split(' ')[1] === 'minutes' ? 'mins' : 'seconds';

    return (
      <PopupWrapper>
        <NewPopupTitle>Are you sure you want to go offline?</NewPopupTitle>
        <NewPopupSubtitle>
          The platform is designed to route tickets to high-performing Experts who remain online. Going offline will
          prevent you from receiving more tickets, and you won’t be able to come back online for {timeAmount} {timeUnit}
          . If you do go offline, you can continue to work on any tickets you’ve already accepted.
        </NewPopupSubtitle>
        <NewPopupSubtitle>
          <strong>Getting busy?</strong> The platform won’t send you more tickets than you can handle; just answer
          tickets in the order you receive them to maintain excellent performance and maximize your earnings!
        </NewPopupSubtitle>
        <CheckBoxWrapper>
          <Checkbox type="checkbox" checked={doNotShowThisMessageAgain} onChange={(e) => this.handleCheckBoxClick(e)} />
          <p>Do not show this message again</p>
        </CheckBoxWrapper>
        <br />
        <ButtonHolder>
          <CommonBlueButton width={'50%'} onClick={() => this.handleClosePopup()}>
            Remain Online
          </CommonBlueButton>
          <ExpertToggleLockCancelButton onClick={(e) => this.handleAcknowledgeButtonClick(e)}>
            Go Offline ({lockExpiresIn})
          </ExpertToggleLockCancelButton>
        </ButtonHolder>
      </PopupWrapper>
    );
  }
}

const showExpertToggleLockPopupComponent = (simplrExpertId, toggleButton = false, resolve = undefined) =>
  createPopup({
    type: 'ToggleLockPopup',
    title: null,
    content: <ToggleLockPopup expertId={simplrExpertId} toggleButton={toggleButton} resolve={resolve} />,
    noOverlay: false,
    closeOnOutsideClick: false,
  });

export { showExpertToggleLockPopupComponent };
